// extracted by mini-css-extract-plugin
module.exports = {"Links":"menu_Links__VMW5I"};